// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__39SYl","productName":"Table_productName__2w-dh"};